module.exports = __webpack_public_path__ + "static/img/favicon_blanco.4836db84.png";